import { Car, BatteryCharging, Disc, Thermometer, Fuel } from 'lucide-react';

// `addedDate` (ISO date) is used only as a Trending tie-breaker (most recently added
// first) when visit counts are equal or absent — this catalog has no other date field.
// Set to each simulator's actual ship date; new entries should get today's date.
export const SIMULATOR_CATALOG = [
  {
    icon: Car,
    title: 'EV Powertrain Simulator',
    to: '/simulation/ev-powertrain',
    description: 'Run a full vehicle-dynamics simulation: size the motor and battery pack, then simulate performance and energy consumption.',
    addedDate: '2026-08-04',
  },
  {
    icon: BatteryCharging,
    title: 'Charging Simulator',
    to: '/simulation/charging',
    description: 'Model realistic CC-CV EV charging behavior — voltage, current, and power over time — instead of a naive energy ÷ power estimate.',
    addedDate: '2026-08-05',
  },
  {
    icon: Disc,
    title: 'Regenerative Braking Blending Simulator',
    to: '/simulation/regen-braking',
    description: 'Split drive-cycle braking between regen and friction brakes — limited by battery SoC and temperature, motor torque and axle stability — and see the range regen adds.',
    addedDate: '2026-09-30',
  },
  {
    icon: Thermometer,
    title: 'Battery Pack Thermal Simulator',
    to: '/simulation/battery-thermal',
    description: 'Pack, cell-core and coolant temperatures over a drive cycle or DC fast charge — with BMS power derating and a side-by-side comparison of five cooling strategies.',
    addedDate: '2026-10-01',
  },
  {
    icon: Fuel,
    title: 'HEV Energy Management Simulator',
    to: '/simulation/hev-energy-management',
    description: 'Drive a parallel hybrid through WLTC, MIDC or US06 with a rule-based controller and with ECMS, charge-sustaining, and compare fuel, CO₂ and engine operating points against the same car without its hybrid system.',
    addedDate: '2026-10-04',
  },
];

// Maps a simulator into the shared TrendingSection item shape (see TrendingSection.jsx).
export const simulatorToTrendingItem = (sim) => ({
  id: sim.to,
  to: sim.to,
  title: sim.title,
  description: sim.description,
  icon: sim.icon,
  updatedAt: sim.addedDate,
});
